import { Link } from "react-router-dom"

export default function SMSTermsPage() {
  const currentYear = new Date().getFullYear()

  return (
    <article
      style={{
        maxWidth: 760,
        width: "100%",
        margin: "0 auto",
        padding: "clamp(24px, 6vw, 48px) clamp(20px, 4vw, 32px)",
        display: "grid",
        gap: "clamp(20px, 3vw, 28px)",
      }}
    >
      <header>
        <h1
          className="mono"
          style={{
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            fontSize: "clamp(1.4rem, 4vw, 1.8rem)",
            marginBottom: "12px",
          }}
        >
          SMS Terms of Service
        </h1>
        <p className="small" style={{ color: "var(--muted)" }}>
          Last Updated: January {currentYear}
        </p>
      </header>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          About Our SMS Service
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Sales Demon (&ldquo;we,&rdquo; &ldquo;us,&rdquo; &ldquo;our&rdquo;) provides SMS notifications to help you manage your
          business operations, including invoice delivery, payment confirmations, payment
          reminders, and account updates. These terms govern your use of our SMS messaging
          service.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Messages You&apos;ll Receive
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7, marginBottom: "12px" }}>
          When you opt in to SMS notifications, you may receive messages about:
        </p>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>
            <strong style={{ color: "var(--text)" }}>Invoice confirmations</strong> – When you
            create and send invoices
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Payment notifications</strong> – When your
            customers pay invoices
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Payment reminders</strong> – Automated
            reminders for overdue invoices
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Account updates</strong> – Important
            information about your Sales Demon account
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Command responses</strong> – Replies to
            text commands you send
          </li>
        </ul>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Message Frequency
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Message frequency varies based on your account activity. Typical users receive 5-20
          messages per week, depending on their invoicing volume and customer payment activity.
          Users who actively use text commands will receive more messages.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          How to Opt In
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7, marginBottom: "12px" }}>
          You can opt in to SMS notifications by:
        </p>
        <ol style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>Providing your phone number during account registration</li>
          <li>Checking the SMS consent checkbox during signup</li>
          <li>Verifying your phone number with the code we send</li>
        </ol>
        <p style={{ color: "var(--muted)", lineHeight: 1.7, marginTop: "12px" }}>
          By opting in, you confirm that you are the owner or authorized user of the phone
          number provided and consent to receive automated SMS messages from Sales Demon.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          How to Opt Out
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7, marginBottom: "12px" }}>
          You can opt out of SMS notifications at any time by:
        </p>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>
            Replying <strong style={{ color: "var(--text)" }}>STOP</strong> to any message from
            Sales Demon
          </li>
          <li>
            Using alternative keywords:{" "}
            <strong style={{ color: "var(--text)" }}>UNSUBSCRIBE, CANCEL, END, QUIT</strong>
          </li>
          <li>Contacting support at support@salesdemon.ai</li>
        </ul>
        <p style={{ color: "var(--muted)", lineHeight: 1.7, marginTop: "12px" }}>
          After opting out, you will receive one final confirmation message. You will no longer
          receive SMS notifications, but you can still access your account via our web
          application. To re-subscribe, reply <strong style={{ color: "var(--text)" }}>START</strong>{" "}
          or contact support.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          How to Get Help
        </h2>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>
            Reply <strong style={{ color: "var(--text)" }}>HELP</strong> to any message for
            assistance
          </li>
          <li>
            Email:{" "}
            <a href="mailto:support@salesdemon.ai" style={{ color: "var(--accent-text)" }}>
              support@salesdemon.ai
            </a>
          </li>
          <li>
            Visit:{" "}
            <Link to="/help" style={{ color: "var(--accent-text)" }}>
              salesdemon.ai/help
            </Link>
          </li>
        </ul>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Costs
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Sales Demon does not charge for SMS messages. However,{" "}
          <strong>message and data rates may apply</strong> depending on your mobile carrier and
          plan. Check with your carrier for details about your messaging plan.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Supported Carriers
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Our SMS service is supported on all major U.S. carriers including AT&amp;T, Verizon,
          T-Mobile, US Cellular, and regional carriers. Carrier support may vary for
          international numbers.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Privacy
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Your phone number and SMS data are handled according to our{" "}
          <Link to="/legal/privacy" style={{ color: "var(--accent-text)" }}>
            Privacy Policy
          </Link>
          . Key points:
        </p>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px", marginTop: "12px" }}>
          <li>
            We do <strong style={{ color: "var(--text)" }}>not</strong> sell or share your phone
            number with third parties for marketing purposes
          </li>
          <li>
            SMS opt-in data and consent will not be shared with third parties
          </li>
          <li>
            Your phone number is used solely to provide Sales Demon services
          </li>
          <li>
            We may share data with service providers (e.g., Twilio) solely to deliver messages
          </li>
        </ul>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Changes to These Terms
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          We may update these SMS terms from time to time. We will notify you of significant
          changes via SMS or email. Continued use of our SMS service after changes constitutes
          acceptance of the updated terms.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Contact Us
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Questions about our SMS service?
          <br />
          Email:{" "}
          <a href="mailto:support@salesdemon.ai" style={{ color: "var(--accent-text)" }}>
            support@salesdemon.ai
          </a>
          <br />
          Web:{" "}
          <a href="https://salesdemon.ai" style={{ color: "var(--accent-text)" }}>
            salesdemon.ai
          </a>
        </p>
      </section>

      <footer
        style={{
          marginTop: "16px",
          paddingTop: "20px",
          borderTop: "1px solid var(--rail)",
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <Link
          to="/legal/sms-compliance"
          className="mono small"
          style={{ color: "var(--accent-text)", letterSpacing: "0.08em" }}
        >
          SMS Message Flow →
        </Link>
        <Link
          to="/legal/privacy"
          className="mono small"
          style={{ color: "var(--accent-text)", letterSpacing: "0.08em" }}
        >
          Privacy Policy →
        </Link>
        <Link
          to="/legal/terms"
          className="mono small"
          style={{ color: "var(--accent-text)", letterSpacing: "0.08em" }}
        >
          Terms of Service →
        </Link>
        <Link
          to="/"
          className="mono small"
          style={{ color: "var(--muted)", letterSpacing: "0.08em" }}
        >
          ← Back to Home
        </Link>
      </footer>
    </article>
  )
}
